import React from 'react';
import HeroSection from './components/HeroSection';
import FlowchartSection from './components/FlowchartSection';
import FeaturesSection from './components/FeaturesSection';
import SignupSection from './components/SignupSection';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Top hero section with logo and product description */}
      <HeroSection />
      {/* Diagram explaining how the service works */}
      <FlowchartSection />
      {/* Key features overlayed on a background image */}
      <FeaturesSection />
      {/* Waitlist sign‑up form */}
      <SignupSection />
    </div>
  );
}

export default App;